<template>
    <modal
        :name="modalName"
        transition="pop-out"
        :width="width"
        height="auto"
        scrollable
        :adaptive="true"
        :click-to-close="false"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2 class="text-dark">
                            <slot name="header">{{ title }}</slot>
                        </h2>
                    </div>
                    <div class="col-2 text-right">
                        <button
                            type="button"
                            class="close"
                            :aria-label="closeLabel"
                            @click.prevent="cerrar()"
                        >&times;</button>
                    </div>
                </div>
            </div>
            <div class="card-body p-0">
                <slot name="body">
                    <iframe
                        v-if="pdfUrl"
                        :src="pdfUrl"
                        :title="title"
                        class="reglamento-iframe"
                    ></iframe>
                </slot>
            </div>
            <div class="card-footer text-right">
                <slot name="footer">
                    <Button type="button" :label="buttonLabel" @click.prevent="cerrar()" />
                </slot>
            </div>
        </div>
    </modal>
</template>

<script>
    import Button from '@/modules/ui/Button.vue';

    /**
     * Modal reutilizable para enseñar un reglamento (o cualquier documento)
     * dentro de la app. Se apoya en vue-js-modal: cada instancia necesita un
     * `modalName` propio, porque el plugin busca los modales por nombre.
     *
     * Los textos se pasan desde quien lo usa (`title`, `buttonLabel`,
     * `closeLabel`) para que vayan por i18n; el componente no traduce nada.
     *
     * Se queda en Options API porque la etiqueta `<modal>` la registra el
     * plugin de forma global y `<script setup>` no la resuelve en Vue 2.7.
     */
    export default {
        name: 'ModalReglamento',
        components: {
            Button
        },
        props: {
            /** Identificador único del modal (vue-js-modal busca por nombre). */
            modalName: {
                type: String,
                required: true,
                validator: value => /^[a-z0-9-]+$/i.test(value)
            },
            title: {
                type: String,
                default: ''
            },
            pdfUrl: {
                type: String,
                default: ''
            },
            buttonLabel: {
                type: String,
                default: ''
            },
            closeLabel: {
                type: String,
                default: ''
            },
            width: {
                type: Number,
                default: 900
            }
        },
        methods: {
            cerrar() {
                this.$emit('cerrar');
                this.$modal.hide(this.modalName);
            }
        }
    }
</script>

<style scoped>
    .reglamento-iframe {
        width: 100%;
        height: 70vh;
        border: 0;
        display: block;
    }
</style>
